/* =============================================================================
 * SchoolCardSkeleton — content-shaped loading placeholder for the matches grid.
 * Built on the Card + Skeleton primitives (Track D) so it can't drift from the
 * real card. Replaces the "Loading schools..." spinner text — the audit's biggest
 * perceived-performance miss.
 * ========================================================================== */
import React from 'react';
import { Card, Skeleton } from './ui';

export const SchoolCardSkeleton: React.FC = () => (
  <Card aria-hidden>
    {/* header: logo + name lines */}
    <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
      <Skeleton variant="rect" width={56} height={56} radiusPx={8} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'center' }}>
        <Skeleton variant="line" width="70%" height={16} />
        <Skeleton variant="line" width="45%" height={12} />
      </div>
    </div>
    {/* division / conference chips */}
    <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
      <Skeleton variant="line" width={72} height={24} radiusPx={999} />
      <Skeleton variant="line" width={96} height={24} radiusPx={999} />
    </div>
    {/* roster-need band */}
    <Skeleton variant="rect" height={52} radiusPx={12} style={{ marginBottom: 16 }} />
    {/* stat strip */}
    <div style={{ display: 'flex', gap: 16, padding: '16px 0', borderTop: '1px solid var(--aps-border)', borderBottom: '1px solid var(--aps-border)', marginBottom: 16 }}>
      {[0, 1, 2].map((i) => (
        <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'center' }}>
          <Skeleton variant="line" width={40} height={10} />
          <Skeleton variant="line" width={30} height={14} />
        </div>
      ))}
    </div>
    {/* action row */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
      {[0, 1, 2].map((i) => (
        <Skeleton key={i} variant="rect" width={36} height={36} radiusPx={8} />
      ))}
    </div>
  </Card>
);

export default SchoolCardSkeleton;
